import * as yup from "yup";

export const codeVerificationSchema = yup.object().shape({
    verification_code: yup.string().required("Field is required"),
});
